export const SHOW = 'prevenx/modalForm/SHOW'
export const DISMISS = 'prevenx/modalForm/DISMISS'
export const SHOW_PREVIOUS = 'prevenx/modalForm/SHOW_PREVIOUS'
export const PERSIST = 'prevenx/modalForm/PERSIST'
